import React from 'react';
import { Box } from '@mui/material';

export interface ListContainerProps {
  children: React.ReactNode;
}

export const ListContainer: React.FC<ListContainerProps> = ({ children }) => {
  return (
    <Box display="flex" flexDirection="column" width={{ xs: '100%', sm: '50%', md: '40%' }}>
      {children}
    </Box>
  );
};
